function reportApiError(error: Error) {
  // TODO: report to Error to AirBrake
}

// GQL style interface for response
type APIResponse<T> = {
  error: Error | boolean;
  data?: T;
};

const fetchData = async <ResultType>(
  url: string | URL,
  config?: RequestInit
): Promise<APIResponse<ResultType>> => {
  try {
    const response = await fetch(url, config);
    if (!response.ok) {
      const error = new Error(response.statusText);
      throw error;
    }
    const data = (await response.json()) as ResultType;
    return {
      data,
      error: false,
    };
  } catch (error) {
    // error is any type - so do an instance check
    if (error instanceof Error) {
      console.error(error.message);
    } else {
      console.error("Unexpected error", error);
    }
    reportApiError(error as Error);
    return {
      error: error as Error,
    };
  }
};

export default fetchData;
